import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">内容精选</h2>
          <p className="mt-2 text-sm text-foreground-600">精选黑料内容专题视频与深度分析</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article key={item.id} className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all hover:ring-2 hover:ring-primary-200">
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
                <div className="absolute inset-0 bg-black/10 pointer-events-none"></div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 text-[11px] font-medium text-background-50 bg-foreground-900/70 rounded">
                  {item.duration}
                </span>
                <span className="absolute top-3 left-3 px-2.5 py-0.5 text-[11px] font-semibold text-background-50 bg-primary-500/90 rounded-md">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between mt-3 text-xs text-foreground-500">
                  <span>{item.source}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-xs"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}